import type { ReactNode } from "react";

type Tone = "neutral" | "success" | "warning" | "danger" | "info" | "accent";

const toneStyles: Record<Tone, string> = {
  neutral: "bg-ink-100 text-ink-700 border-line",
  success: "bg-success-bg text-success border-success-border",
  warning: "bg-warning-bg text-warning border-warning-border",
  danger: "bg-danger-bg text-danger border-danger-border",
  info: "bg-info-bg text-info border-info-border",
  accent: "bg-accent-50 text-accent-600 border-accent-100",
};

/**
 * A bordered soft-fill rectangle at 10px radius — deliberately not a fully
 * rounded pill, and deliberately one size only. Status is information, not
 * decoration, so it stays quiet.
 */
export function Badge({
  children,
  tone = "neutral",
  icon,
}: {
  children: ReactNode;
  tone?: Tone;
  icon?: ReactNode;
}) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-medium ${toneStyles[tone]}`}
    >
      {icon}
      {children}
    </span>
  );
}
